/** 产品碳足迹表单名词解释 */
export const CARBON_FOOTPRINT_TERM_TIPS = {
  functionalUnit:
    '指核算碳排放的基础单位，即"多少产品产生的排碳量"。通常以重量、件数或长度计。',
  systemBoundary: '产品碳足迹核算具体包含哪些阶段。',
  carbonUnitValue:
    '每单位产品（例如：一吨钢材）在边界内排放的二氧化碳当量的总和。示例：840 kgCO₂e/吨钢材（表示生产1吨钢材排放840千克二氧化碳当量）。',
  timeBoundary:
    '产品碳足迹核算分析的时间跨度。例如：2025年1月1日到2025年12月31日。',
};

export const REPORT_OR_CERT_UPLOAD_TIP = '碳足迹报告和证书请至少上传一份';
export const REPORT_OR_CERT_UPLOAD_ERROR = '碳足迹报告和证书请至少上传一份。';
export const DELETE_CONFIRM_MESSAGE = '您确认要删除吗？不可恢复！';
